import { render, staticRenderFns } from "./ScalingSquaresSpinner.vue?vue&type=template&id=3c45733a&scoped=true"
import script from "./ScalingSquaresSpinner.vue?vue&type=script&lang=js"
export * from "./ScalingSquaresSpinner.vue?vue&type=script&lang=js"
import style0 from "./ScalingSquaresSpinner.vue?vue&type=style&index=0&id=3c45733a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../vue-loader@15.11.1_babel-core@6.26.3_css-loader@4.3.0_lodash@4.17.21_prettier@1.19.1_vue-temp_lls4wxv5ipnxzldxaoogv2ybrq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c45733a",
  null
  
)

export default component.exports